import React from 'react';
import { CreditCard, Banknote, ArrowLeft, MapPin, Tag, X, Check, Gift, Store, Truck, Clock, Plus, ChevronRight, Trash2, Phone, CalendarDays } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { formatPrice } from '../../lib/utils';
import StampCard from '../StampCard';

const ContactInfoCard = ({
  email,
  name,
  phone,
  setEmail,
  setName,
  setPhone,
  t,
  user,
}) => (
  <>
              <Card className="bg-[#141417] border-[#27272A]">
                <CardHeader>
                  <CardTitle>{t('checkout.contactInfo')}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label htmlFor="name">{t('checkout.name')} *</Label>
                      <Input
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="bg-[#0B0B0C] border-[#27272A] focus:border-[#FFC107]"
                        data-testid="checkout-name"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="phone">{t('checkout.phone')} *</Label>
                      <Input
                        id="phone"
                        type="tel"
                        value={phone}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9+]/g, '');
                          setPhone(val);
                        }}
                        required
                        pattern="[0-9+]+"
                        className="bg-[#0B0B0C] border-[#27272A] focus:border-[#FFC107]"
                        data-testid="checkout-phone"
                      />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="email">{t('checkout.email')} *</Label>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => !user && setEmail(e.target.value)}
                      required
                      readOnly={!!user}
                      className={`bg-[#0B0B0C] border-[#27272A] focus:border-[#FFC107] ${user ? 'opacity-60 cursor-not-allowed' : ''}`}
                      data-testid="checkout-email"
                    />
                  </div>
                </CardContent>
              </Card>
  </>
);

export default ContactInfoCard;
